import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-app-qr-code',
  templateUrl: './app-qr-code.component.html',
  styleUrls: ['./app-qr-code.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppQrCodeComponent implements OnInit {
  @Input() qrCodeData = '';
  data = '';
  width = 320;
  showQRCode = false;
  autoDownload = false;
  @ViewChild('qrContainer') qrContainer: ElementRef<HTMLDivElement>;

  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
  }

  setData(data) {
    this.data = data;
  }

  setWidth(width) {
    this.width =  width ? width : 320;
  }

  setAutoDownload(autoDownload: boolean) {
    this.autoDownload = !!autoDownload;
  }

  generate() {
    this.showQRCode = true;
    if (this.autoDownload) {
      setTimeout(() => this.downloadQRCode(), 0);
    }
  }

  close() {
    this.activeModal.close();
  }

  private downloadQRCode() {
    if (!this.qrContainer || !this.qrContainer.nativeElement) {
      return;
    }

    const svg = this.qrContainer.nativeElement.querySelector('svg');
    if (svg) {
      const serializer = new XMLSerializer();
      const svgString = serializer.serializeToString(svg);
      const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      this.triggerDownload(url, 'visitor-qr.svg');
      URL.revokeObjectURL(url);
      return;
    }

    const canvas = this.qrContainer.nativeElement.querySelector('canvas') as HTMLCanvasElement;
    if (canvas) {
      const url = canvas.toDataURL('image/png');
      this.triggerDownload(url, 'visitor-qr.png');
    }
  }

  private triggerDownload(url: string, filename: string) {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
  }

}
